<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-fitler_fields">
    <b-col class="giga-fitler_field_col_4">
      <div class="giga-custom_select">
        <b-form-select v-model="filter.query" @change="onChange">
          <b-form-select-option
            v-for="field of config.fields"
            :key="field.element"
            :value="field"
          >
            {{ $t(field.name) }}
          </b-form-select-option>
        </b-form-select>
      </div>
    </b-col>

    <b-col class="giga-fitler_field_col_3">
      <div class="giga-custom_select">
        <b-form-select v-model="filter.operator">
          <b-form-select-option
            v-for="oper of getRuleTypes()"
            :key="oper.key"
            :value="oper"
          >
            {{ oper.value }}
          </b-form-select-option>
        </b-form-select>
      </div>
    </b-col>

    <b-col class="giga-fitler_field_col_5" v-if="filter.query">
      <!--type number-->
      <template v-if="filter.query.type === 'number'">
        <b-form-input
          :id="filter.value"
          v-model="filter.value"
          :type="filter.query.type"
          :placeholder="filter.query.name"
        ></b-form-input>
      </template>
      <!--type date-->
      <template v-else-if="filter.query.type === 'date'">
        <date-picker
          v-model="filter.value"
          format="dddd D MMMM YYYY"
          valueType="YYYY-MM-DD"
          prefix-class="xmx"
          :placeholder="filter.query.name"
          :clearable="false"
          :editable="false"
        >
          <template slot="icon-calendar">
            <b-icon icon="calendar3"></b-icon>
          </template>
        </date-picker>

        <!-- <b-form-datepicker
              :id="filter.value"
              v-model="filter.value"
              :locale="locale"
              :placeholder="filter.query.name"
              class="button-content-right"
              right
              no-flip
          >
            <template slot="button-content">
                            <span class="text-primary">
                              <b-icon icon="calendar3"></b-icon>
                            </span>
            </template>
          </b-form-datepicker> -->
      </template>
      <!--type select-->
      <template
        v-else-if="
          filter.query.type === 'select' || filter.query.type === 'multiselect'
        "
      >
        <!-- :max-height="300" -->
        <multiselect
          v-model="filter.value"
          v-select-overflow
          open-direction="bottom"
          :closeOnSelect="false"
          :options="filter.query.options"
          :placeholder="filter.query.name"
          :multiple="filter.query.type === 'multiselect'"
          trackBy="value"
          label="name"
          :showLabels="false"
          class="tags-outline"
          :searchable="
            filter.query.element === 'agence' || filter.query.element === 'user'
          "
        >
          <template slot="caret">
            <div
              class="multiselect__select d-flex align-items-center justify-content-center"
            >
              <div
                v-if="filter.value && filter.value.length"
                class="text-primary"
              >
                <b-icon icon="pencil-fill"></b-icon>
              </div>
              <div v-else>
                <b-icon icon="chevron-down"></b-icon>
              </div>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc d-flex justify-content-between">
              <span class="option__title">{{ props.option.name }}</span>
            </div>
          </template>
        </multiselect>
      </template>
      <!--type text-->
      <template v-else>
        <b-form-input
          :id="filter.query.element"
          v-model="filter.value"
          :type="filter.query.type"
          :placeholder="$t(filter.query.name)"
        ></b-form-input>
      </template>
    </b-col>
  </div>
</template>

<script>
import { agenceService } from "@/views/service/agence.service";
import { mapGetters } from "vuex";
import { userService } from "@/views/service/user.service";
export default {
  name: "FilterElement",
  props: ["config", "filter"],
  data() {
    return {
      locale: "fr",
      ruleTypes: {
        text: {
          operators: [
            { key: "=", value: "égal à" },
            { key: "contains", value: "contient" },
            { key: "!=", value: "différent de" }
          ],
          inputType: "text",
          id: "text-field"
        },
        number: {
          operators: [
            { key: "=", value: "égal à" },
            { key: "<", value: "inférieur à" },
            { key: ">", value: "supérieur à" },
            { key: ">=", value: "égal ou supérieur à" },
            { key: "=<", value: "égal ou inférieur à" },
            { key: "!=", value: "différent de" }
          ],
          inputType: "number",
          id: "number-field"
        },
        select: {
          operators: [{ key: "=", value: "égal à" }],
          choices: [],
          inputType: "select",
          id: "select-field"
        },
        multiselect: {
          operators: [{ key: "=", value: "égal à" }],
          choices: [],
          inputType: "select",
          id: "multi-select-field"
        },
        date: {
          operators: [
            { key: "=", value: "égal à" },
            { key: "<", value: "inférieur à" },
            { key: ">", value: "supérieur à" },
            { key: ">=", value: "égal ou supérieur à" },
            { key: "=<", value: "égal ou inférieur à" }
          ],
          choices: [],
          inputType: "select",
          id: "date-field"
        }
      }
    };
  },
  mounted() {
    if (!this.filter.query) {
      this.filter.query = this.config.fields[0];
    }
    if (!this.filter.operator) {
      this.filter.operator = this.ruleTypes[
        this.filter.query.type
      ].operators[0];
    }
  },
  computed: {
    ...mapGetters("account", { userInfo: "getCurrentUser" })
  },
  methods: {
    onChange() {
      this.filter.operator = this.ruleTypes[
        this.filter.query.type
      ].operators[0];
      this.filter.value = null;
      const selectedElement = this.filter.query;
      if (selectedElement.element === "agence") {
        this.fetchAgences();
      } else if (selectedElement.element === "user") {
        this.fetchUsers();
      }
    },
    getRuleTypes() {
      if (this.filter.query && this.filter.query.type) {
        return this.ruleTypes[this.filter.query.type].operators;
      } else {
        return [];
      }
    },
    fetchAgences() {
      agenceService.allUserAgencesList().then(agencies => {
        this.filter.query.options = agencies.content.map(function(agency) {
          return {
            name: agency.raisonSocial,
            value: agency
          };
        });
      });
    },
    fetchUsers() {
      if (this.userInfo.admin) {
        userService.clientUsersList().then(users => {
          this.filter.query.options = users.map(function(user) {
            return {
              name: user.username,
              value: user
            };
          });
        });
      } else if (this.userInfo.role?.roleType == "ADMIN_AGENCE") {
        userService.agenceUsersList(this.userInfo.agence.id).then(users => {
          this.filter.query.options = users.map(function(user) {
            return {
              name: user.username,
              value: user
            };
          });
        });
      }
    }
  }
};
</script>

<style scoped></style>
